import { FunctionComponent } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Moment } from 'moment-timezone';
import styles from './CalendarBooking.module.scss';

interface CalendarBookingProps {
    date: Moment;
    onDaySelect: (value: Date) => void;
}

export const CalendarBooking: FunctionComponent<CalendarBookingProps> = props => {
    const changeDate = (daySelect: Date) => {
        props.onDaySelect(daySelect);
    };

    return (
        <Calendar
            calendarType="US"
            onChange={(value: any) => changeDate(value)}
            value={props.date.toDate()}
            className={styles.calendar}
            nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
            prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
            prev2Label={null}
            next2Label={null}
            showNeighboringMonth={false}
            locale={'en'}
        />
    );
};

export default CalendarBooking;
